import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { useBulkArenaAccess } from "./hooks";

type EndBulkArenaAccessModalProps = {
  isOpen: boolean;
  userId: string;
  roleGroupName: string;
  onClose: () => void;
};

export const EndBulkArenaAccessModal = ({
  isOpen,
  onClose,
  userId,
  roleGroupName,
}: EndBulkArenaAccessModalProps) => {
  const { endBulkArenaAccess, loading } = useBulkArenaAccess({ userId });
  const handleEndBulkArenaAccess = async () => {
    const success = await endBulkArenaAccess();

    if (success) {
      onClose();
    }
  };

  return (
    <ModalV2
      show={isOpen}
      onHide={onClose}
      title="Disable access to all client workspaces"
      size="small"
      data-testid="end-bulk-arena-access-modal"
    >
      <ModalV2.Body>
        <Text variant="regular-md">
          This user will lose their {roleGroupName ? `${roleGroupName} ` : ""}
          access across all FA-managed workspaces. Named workspace assignments are not affected.
        </Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex flexDirection="row" justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button variant="neutral" type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            type="button"
            onClick={handleEndBulkArenaAccess}
            isLoading={loading}
            disabled={loading}
          >
            Disable
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
